import api from "../configurations/axios";
import OrderDetails from "../models/OrderDetails";
import getOrderDetailsByIdResponse from "../responses/GetOrderDetailsByIdResponse";

class OrderService {
    async getOrderDetails(orderDetails: OrderDetails) {
        try {
            const response = await api.get(
                "/api/orders/search",
                ({
                    params: {
                        orderId: orderDetails.orderId,
                        userId: orderDetails.userId,
                        emailAddress: orderDetails.emailAddress,
                    },
                }) as any);
            return response;
        } catch (error) {
            console.error("error:", error.response?.data || error.message);
            console.log("error:", error.response?.data || error.message);

        }
    }

    async getOrderDetailsById(orderId: string) : Promise<getOrderDetailsByIdResponse> {
        try {
            const response = await api.get<getOrderDetailsByIdResponse>(`/api/orders/${orderId}`);
            return response.data;
        } catch (error) {
            throw error;           
        }
    }

    async sendOrderEmail(orderId: string) {
        try {
            await api.post(`/api/orders/${orderId}/send-email`);
        } catch (error) {
            throw error;
        }
    }
}

export default new OrderService();